import { useQuery } from '@tanstack/react-query'
import { getThumbnailsBatch } from '../api/imagenes'

/**
 * Hook para cargar thumbnails de múltiples eventos
 */
export const useThumbnails = (idEventos) => {
  return useQuery({
    queryKey: ['thumbnails', idEventos],
    queryFn: () => getThumbnailsBatch(idEventos),
    enabled: idEventos && idEventos.length > 0,
    staleTime: 10 * 60 * 1000, // 10 minutos - las imágenes no cambian frecuentemente
    // La respuesta es: { code, payload: { Thumbnails: [...] }, message }
  })
}
